import { render, staticRenderFns } from "./UpdateOrder.vue?vue&type=template&id=32df68b4&"
import script from "./UpdateOrder.vue?vue&type=script&lang=js&"
export * from "./UpdateOrder.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOrder.vue?vue&type=style&index=0&id=32df68b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports